import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Evaluador',
            headerName: getLocalizedString("descendingEvaluator"),
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Evaluado',
            headerName: getLocalizedString("evaluated"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Estado de la nota',
            headerName: getLocalizedString("noteStatus"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Calibración realizada',
            headerName: getLocalizedString("calibrationCompleted"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Evaluación aceptada por el evaluado',
            headerName: getLocalizedString("evaluationAcceptedByEvaluated"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Qty calificaciones mínimas',
            headerName: getLocalizedString("minimumRatingsQtyDot"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Qty calificaciones máximas',
            headerName: getLocalizedString("maxRatingsQty"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota final desempeño calibrada',
            headerName: getLocalizedString("calibratedPerformanceFinalGrade"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota numérica desempeño calibrada',
            headerName: getLocalizedString("calibratedPerformanceNumericScore"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "ProgressByRankingRendererDynamicColor",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Ranking',
            headerName: getLocalizedString("ranking"),
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota final desempeño estándar',
            headerName: getLocalizedString("finalStandardPerformanceScore"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota numérica desempeño estándar',
            headerName: getLocalizedString("standardPerformanceNumericScore"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: "Indicador de desempeño",
            headerName: getLocalizedString("performanceIndicator"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'IndicatorRenderer'
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota final potencial calibrada',
            headerName: getLocalizedString("finalCalibratedPotentialGrade"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota numérica potencial calibrada',
            headerName: getLocalizedString("calibratedPotentialNumericScore"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota final potencial estándar',
            headerName: getLocalizedString("standardPotentialFinalScore"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Nota numérica potencial estándar',
            headerName: getLocalizedString("numericStandardPotentialScore"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: "Indicador de potencial",
            headerName: getLocalizedString("potentialIndicator"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(2, 2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'IndicatorRenderer'
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: "Fecha de calibración",
            headerName: getLocalizedString("calibrationDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },

    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: "Responsable calibración",
            headerName: getLocalizedString("calibrationResponsible"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: 'Grupo de calibración',
            headerName: getLocalizedString("calibrationCommittee"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            field: "Comentarios de la calibración",
            headerName: getLocalizedString("calibrationComments"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },

    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "Centro de costo de gestión",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceEvaluationsCalibration],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "Unidad de negocio",
            filter: "agSetColumnFilter",
        }
    },

    // grilla 1 de graficos
    {
        pages: ['performanceEvaluationsCalibrationsBySkills'],
        config: {
            headerName: getLocalizedString("competence"),
            field: 'skill',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsBySkills'],
        config: {
            headerName: getLocalizedString("competenciesAverage"),
            field: 'skillAverage',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },

    // grilla 2 de graficos
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("evaluated"),
            field: 'evaluated',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
            pinned: "left",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("photograph"),
            field: 'image',
            filter: "agTextColumnFilter",
            cellRenderer: "AvatarRenderer",
            pinned: "left",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("competenciesAverage"),
            field: 'average',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("wasCalibrated"),
            field: 'calibrated',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("category"),
            field: "category",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("function"),
            field: "function",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("management"),
            field: "management",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("department"),
            field: "department",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "workOrTask",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenter',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'workplace',
            filter: 'agSetColumnFilter',
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsByEvaluated'],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'functionaryType',
            filter: 'agSetColumnFilter',
        }
    },

    // grilla evaluados y grupo de calibración
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("descendingEvaluator"),
            field: 'evaluator',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("finalGrade"),
            field: 'finalNote',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("evaluated"),
            field: 'evaluated',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("numericScore"),
            field: 'numericNote',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("group"),
            field: 'group',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("minimumScores"),
            field: 'minQualification',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsEvaluatedAndCalibrationGroup'],
        config: {
            headerName: getLocalizedString("maximumRatings"),
            field: 'maxQualification',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },

    // grilla ranking
    {
        pages: ['performanceEvaluationsCalibrationsRanking'],
        config: {
            headerName: getLocalizedString("evaluator"),
            field: 'evaluator',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsRanking'],
        config: {
            headerName: getLocalizedString("numberOfEvaluated"),
            field: 'evaluatedAmount',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['performanceEvaluationsCalibrationsRanking'],
        config: {
            headerName: getLocalizedString("averageRanking"),
            field: 'ranking',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(1, 1),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]